import type { Resource } from '../../';
export const cart_couponCodes_rejection_notApplicable: Resource = {"default":"The requested coupon cannot be applied to this bag."};
